// extracted by mini-css-extract-plugin
export default {"root":"Header_root__Ms9ey","left":"Header_left__7ASFC","right":"Header_right__73Vwr"};